export const convertAgeToDecade = (age) => {
	if (typeof age !== 'number' || !Number.isInteger(age) || age < 0) {
		console.log(`${age} is Invalid age. Age must be a non-negative integer.`)
		return ''
	}

	const decade = Math.floor(age / 10) * 10
	return `${decade}代`
}
